/** The labels of the navigation catalogue (partials/navItems.ts): sidebar, rail, phone tab bar and More menu. */
export const nav = {
    mainLabel: "Main",
    more: "More",
    groups: {
        gettingStarted: "Getting Started",
        operations: "Operations",
        sterfive: "Sterfive",
    },
    items: {
        overview: "Overview",
        documentation: "Documentation",
        documentationShort: "Docs",
        token: "Your Token",
        agents: "Agents & Servers",
        agentsShort: "Agents",
        monitoring: "Monitoring",
        notifications: "Notifications",
        download: "Download Agent",
        downloadShort: "Download",
        organisation: "Organisation",
        gds: "GDS",
        admin: "Admin",
        hostedGds: "Hosted GDS",
    },
};
